import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import Link from 'next/link';
import { useState } from 'react';

const PRICE_BASIS_LABELS = {
  hour: { prefix: 'Stundenpreise', unit: 'Std.' },
  day: { prefix: 'Tagespreise', unit: 'Tag' },
  week: { prefix: 'Wochenpreise', unit: 'Woche' },
  month: { prefix: 'Monatspreise', unit: 'Monat' },
};

function FaqSection({
  categoryName,
  categorySingular,
  articleDe,
  locationName,
  abPreisTag,
  priceBasis,
  priceFactor,
}) {
  const [expanded, setExpanded] = useState(null);

  if (!abPreisTag) return null;

  const { prefix, unit } =
    PRICE_BASIS_LABELS[priceBasis] ?? PRICE_BASIS_LABELS.day;

  const faqs = [
    {
      id: 'speed',
      question: `Wie schnell kann ich ${articleDe} ${categorySingular} in ${locationName} mieten?`,
      answer: `In der Regel erhalten Sie innerhalb von 30 Minuten ein Angebot. Bei Verfügbarkeit ist eine Lieferung in ${locationName} und Umgebung oft am nächsten Werktag möglich.`,
    },
    {
      id: 'cost',
      question: `Was kostet ${articleDe} ${categorySingular} in ${locationName} zu mieten?`,
      answer: `${prefix} beginnen ab ${abPreisTag}\u00A0\u20AC/${unit}. Die Kosten hängen von ${priceFactor} ab.`,
      cta: true,
    },
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant="h6Redesign"
        component="h2"
        color="primary.dark"
        sx={{ mb: 2 }}>
        Häufige Fragen zu {categoryName} in {locationName}
      </Typography>
      {faqs.map(faq => (
        <Accordion
          key={faq.id}
          expanded={expanded === faq.id}
          onChange={(_, isExpanded) => setExpanded(isExpanded ? faq.id : null)}
          elevation={0}
          disableGutters
          sx={{
            borderRadius: 1,
            bgcolor: 'rgba(0, 0, 0, 0.04)',
            mb: 2,
            '&:before': { display: 'none' },
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            sx={{
              minHeight: 'auto',
              '& .MuiAccordionSummary-content': { my: 1.5 },
            }}>
            <Typography
              variant="body1Redesign"
              color={expanded === faq.id ? 'text.primary' : 'text.secondary'}
              fontWeight={expanded === faq.id ? 500 : 400}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0, pl: 4, color: 'text.secondary' }}>
            <Typography variant="body1Redesign">
              {faq.answer}
              {faq.cta && (
                <>
                  {' '}
                  <Link
                    href="/mieten"
                    style={{ color: 'inherit', textDecoration: 'underline' }}>
                    Kostenloses Angebot anfordern
                  </Link>
                </>
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}

export default FaqSection;
